import { Backdrop, CircularProgress } from "@mui/material";
import { useAppSelector } from "../../redux/store";

interface Props {
    children: React.ReactElement;
}

export default function Loading(props: Props) {
    const loadingRequests = useAppSelector(state => state.appState.loadingRequests);

    return (
        <div>
            {props.children}
            <Backdrop
                sx={{ color: "#fff", zIndex: 2147483647 }}
                open={loadingRequests.length !== 0}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}